import React from "react";

import "../styles/error404.css";

const Error404 = () => {
  return (
    <div className="error-404">
      <div className="back-drop">
        <h4>
          ERROR
          <br />
          404
        </h4>
      </div>
    </div>
  );
};

export default Error404;
